import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { COMPONENT_TYPES } from '@shared/config';
import { KpiService, LayoutService } from '@shared/services';
import { DashboardNavigationAnalytic } from '../models/analytic.model';
import { UsageTrackingServiceInterface } from '../models/usage-tracking-service.interface';
import {
  APPLICATION,
  DASHBOARD_TYPES,
  GENERAL_ACTION_TYPES,
} from '../usage-tracking.config';
import { DashboardNavigationInfoService } from './dashboarad-navigation-info.service';
import { TrackingService } from './tracking.service';

@Injectable({ providedIn: 'root' })
export class DashboardNavigationTrackingService implements UsageTrackingServiceInterface {
  private readonly dashboardNavigationInfoService = inject(
    DashboardNavigationInfoService
  );
  private readonly layoutService = inject(LayoutService);
  private readonly kpiService = inject(KpiService);
  private readonly trackingService = inject(TrackingService);
  private readonly router = inject(Router);

  public addUsageTracking(): void {
    const action = GENERAL_ACTION_TYPES.navigation;
    const application = APPLICATION;

    const dashboardNavigationAnalytic: DashboardNavigationAnalytic = {
      url: this.router.url,
      application,
      action,
      ...this.dashboardNavigationInfoService.getNavigationInfo(),
    };

    const hasKpis = this.getHasKpis();
    dashboardNavigationAnalytic.hasKpis = hasKpis;

    if (!hasKpis) {
      dashboardNavigationAnalytic.hasCustomVisuals = this.getHasCustomVisuals(
        DASHBOARD_TYPES.layoutDashboard
      );
      this.trackingService.addUsageTracking(dashboardNavigationAnalytic);
      return;
    }

    if (dashboardNavigationAnalytic.url.includes('mainDashboard')) {
      dashboardNavigationAnalytic.hasCustomVisuals = this.getHasCustomVisuals(
        DASHBOARD_TYPES.mainKpiDashboard
      );
      this.trackingService.addUsageTracking(dashboardNavigationAnalytic);
      return;
    }

    dashboardNavigationAnalytic.hasCustomVisuals = this.getHasCustomVisuals(
      DASHBOARD_TYPES.detailKpiDashboard
    );
    this.trackingService.addUsageTracking(dashboardNavigationAnalytic);
  }

  private getHasKpis(): boolean {
    return this.layoutService.activeLayout.kpis.length > 0;
  }

  public getHasCustomVisuals(dashboard: string): boolean {
    switch (dashboard) {
      case DASHBOARD_TYPES.layoutDashboard:
        return this.layoutService.activeLayout?.dashboard?.dashboardItems?.some(
          dashboardItem =>
            dashboardItem.tile.componentType === COMPONENT_TYPES.customChart
        );
      case DASHBOARD_TYPES.mainKpiDashboard:
        return this.kpiService.activeKpi?.mainDashboard?.dashboardItems?.some(
          dashboardItem =>
            dashboardItem.tile.componentType === COMPONENT_TYPES.customChart
        );
      case DASHBOARD_TYPES.detailKpiDashboard:
        return this.kpiService.activeKpi?.detailDashboard?.dashboardItems?.some(
          dashboardItem =>
            dashboardItem.tile.componentType === COMPONENT_TYPES.customChart
        );
    }
  }
}
